import React, { useState, useRef } from 'react';
import './ChatBot.css';

import Functions from './utils/Functions';



import Lottie from "lottie-react";
import wait from "./anim/wait.json"


import Message from './components/Message';
const ChatBot = ({ initMessages,urlBotImage }) => {


  const [messages, setMessages] = useState([]);

  const [isTyping, setIsTyping] = useState(false);

  const [answers, setAnswers] = React.useState({})



  const containerRef = useRef(null);

  urlBotImage = urlBotImage|| "https://storage.googleapis.com/media.landbot.io/277311/channels/1GTDA9WR9H1MF4E6E8WB4JCGY6YY3VWL.jpg"

  

  function startChat(setMessages, setIsTyping) {
    // debugger

    let next = Functions.getFirstMessage()

    if (next) {
        setMessages((prevMessages) => [...prevMessages, next])
    }
}


  React.useEffect(() => {
    if (!initMessages)
      startChat(setMessages, setIsTyping);
    else
      setMessages(initMessages);

  }, []); // esegue solo al montaggio del componente



React.useLayoutEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollIntoView(
        {
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest'
        })

        
    }
  }, [messages]);

  return (
    <div className='container w-full h-screen'>
      <div ref={containerRef} className="chatbot">

        {messages.map((message, index) => {
          const isLastBotMessage = message.sender === 'bot' && index === messages.findLastIndex(m => m.sender === 'bot');

          /* if (message.sender === "bot")
            return ChatHandler.renderBotMessage(message,isLastBotMessage, setMessages,setIsTyping, messages)
           else
             return (<UserMessage key={"user" + index} msg={message} ></UserMessage>)*/

          return (
            <Message 
              key={"msg_"+index}
              message={message}
              isLastBotMessage={isLastBotMessage}
              setIsTyping={setIsTyping}
              messages={messages}
              setMessages={setMessages}
              answers={answers}
              setAnswers={setAnswers}
              urlBotImage={urlBotImage}
              ></Message>
          )
        })

        }

        {isTyping &&
          <div className='grid'>
            <div className='col-1'>
              <Lottie animationData={wait} loop={true} ></Lottie>
            </div>
          </div>
        }

      </div>

    </div>
  );
};

export default ChatBot;
